import { render, staticRenderFns } from "./ScoringSurveyAccessLinks.vue?vue&type=template&id=105884f7"
import script from "./ScoringSurveyAccessLinks.vue?vue&type=script&lang=ts"
export * from "./ScoringSurveyAccessLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports